import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { HisUploadFile } from '../model/his-upload-file';
import { HisAbstractFileUploadComponent } from './his-abstract-file-upload.component';

@Component( {
    selector: 'his-file-upload-plam[configKey]',
    templateUrl: './his-file-upload-plam.component.html',
    styleUrls: ['./his-file-upload.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisFileUploadPlamComponent extends HisAbstractFileUploadComponent {

    @Input() configKey: string;
    @Input() model: HisUploadFile[] = [];

    label = '';

    protected showValidationMessage(): boolean {
        return false;
    }
}
